import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgGrowth = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M21.9199 6.62C21.8185 6.37565 21.6243 6.18147 21.3799 6.08C21.2597 6.02876 21.1306 6.00158 20.9999 6H15.9999C15.7347 6 15.4804 6.10536 15.2928 6.29289C15.1053 6.48043 14.9999 6.73478 14.9999 7C14.9999 7.26522 15.1053 7.51957 15.2928 7.70711C15.4804 7.89464 15.7347 8 15.9999 8H18.5899L12.9999 13.59L9.70994 10.29C9.61698 10.1963 9.50637 10.1219 9.38452 10.0711C9.26266 10.0203 9.13195 9.9942 8.99994 9.9942C8.86793 9.9942 8.73722 10.0203 8.61536 10.0711C8.4935 10.1219 8.3829 10.1963 8.28994 10.29L2.28994 16.29C2.19621 16.383 2.12182 16.4936 2.07105 16.6154C2.02028 16.7373 1.99414 16.868 1.99414 17C1.99414 17.132 2.02028 17.2627 2.07105 17.3846C2.12182 17.5064 2.19621 17.617 2.28994 17.71C2.3829 17.8037 2.4935 17.8781 2.61536 17.9289C2.73722 17.9797 2.86793 18.0058 2.99994 18.0058C3.13195 18.0058 3.26266 17.9797 3.38452 17.9289C3.50637 17.8781 3.61698 17.8037 3.70994 17.71L8.99994 12.41L12.2899 15.71C12.3829 15.8037 12.4935 15.8781 12.6154 15.9289C12.7372 15.9797 12.8679 16.0058 12.9999 16.0058C13.132 16.0058 13.2627 15.9797 13.3845 15.9289C13.5064 15.8781 13.617 15.8037 13.7099 15.71L19.9999 9.41V12C19.9999 12.2652 20.1053 12.5196 20.2928 12.7071C20.4804 12.8946 20.7347 13 20.9999 13C21.2652 13 21.5195 12.8946 21.707 12.7071C21.8946 12.5196 21.9999 12.2652 21.9999 12V7C21.9984 6.86932 21.9712 6.74022 21.9199 6.62Z"
            fill="currentColor"
        />
    </svg>
);

export const GrowthIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={SvgGrowth}
        fontSize={fontSize}
    />
);
